export const NotFoundPageTranslation = {
  ru: {
    title: 'Страница не найдена',
    linkTitle: 'Перейти на главную страницу',
  },
  en: {
    title: 'Page not found',
    linkTitle: 'Go to the main page',
  },
};
